module.exports = __webpack_public_path__ + "img/nyw.c5211bf1.png";